export const PRIMARY_NAVIGATION_HEIGHT = 50;
export const SECONDARY_NAVIGATION_WIDTH = 56;
export const TERTIARY_NAVIGATION_HEIGHT = 40;

export const VERTICAL_NAVIGATION_HEIGHT = PRIMARY_NAVIGATION_HEIGHT + TERTIARY_NAVIGATION_HEIGHT;
